import { useEffect, useState } from "react";
import { Button } from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import { TextInput } from "../../../../components/TextInput";
import { useApp } from "../../../../services/app-context";
import { getLabel } from "../../utils/labels";

export function DeleteCertificationConfirmation({
    isOpen,
    onClose,
    onConfirm,
    loading,
    region,
}: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    region: any;
}) {
    const { certificationAssets } = useApp();
    const labels = certificationAssets?.labels || {};
    const [inputValue, setInputValue] = useState("");
    useEffect(() => {
        setInputValue("");
    }, [isOpen]);
    return (

        <Modal contentClassName="!w-[400px] [&>.title-container]:!px-0" isOpen={isOpen} handleModal={onClose}>
            <div className="flex flex-col mt-2 gap-4">
                <p className="text-[15px] text-text2">You are about to Delete an active {getLabel("certificationName.singular", labels)}. Would you like to continue?</p>
                <div className="flex flex-col gap-3 mt-4">
                    <div className="text-xs text-text2">Type <strong>DELETE</strong> to continue</div>
                    <TextInput value={inputValue} onChange={(e) => setInputValue(e.target.value)} className="border-primary !py-1" />
                </div>
                <div className="flex justify-end gap-2">
                    <Button variant="primary" loading={loading} disabled={loading || inputValue?.toLowerCase() !== "delete"} onClick={onConfirm} className="px-5 py-0 !h-[35px] !rounded-full bg-[#F22A2A] hover:!opacity-80 hover:!bg-opacity-80">Delete {getLabel("certification.singular", labels)}</Button>
                    <Button variant="outline" onClick={onClose} className="bg-transparent !text-black px-5 h-[35px] !border-0">Cancel</Button>
                </div>
            </div>
        </Modal>
    )
}